// Dev-only harness switch. Gated on BOTH the explicit env flag AND
// a non-production NODE_ENV, so a misset flag in prod is still inert.
export function isMockMode(): boolean {
  if (process.env.NODE_ENV === 'production') {
    return false
  }
  return process.env.NEXT_PUBLIC_MOCK_MODE === '1'
}
